import { includes, isNil } from 'ramda';
import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { optionalString, superRefineHelper } from '@utils/validation';

export const dataConstants = {
	SUICIDAL_THOUGHTS: 'suicidalThoughts',
	VAGUE_THOUGHTS: 'vagueThoughts',
	SPECIFIC_PLAN: 'specificPlan',
	SEVERITY: 'severity',
	SUICIDE_RISK: 'suicideRisk',
};

export const testContent = {
	page_header: "Estrogen isn't recommended for people with certain medical conditions",
	page_subheader: 'Have you been diagnosed with or are you experiencing any of the following?',
	liver_disease_question: 'Cirrhosis, chronic liver failure, or end-stage liver disease?',
	liver_disease_no_choice: 'No',
	liver_disease_yes_choice: 'Yes',
	sensitive_cancers_question:
		'Estrogen or progesterone sensitive cancer (such as breast/chest or uterine/endometrial)',
	sensitive_cancers_yes_choice: 'Yes',
	sensitive_cancers_no_choice: 'No',
	elevated_prolactin_question: 'Elevated prolactin levels (Hyperprolactinemia/Prolactinoma)',
	elevated_prolactin_yes_choice: 'Yes',
	elevated_prolactin_no_choice: 'No',
	yes_choice: 'Yes',
	no_choice: 'No',
	unsure_choice: "I don't know",
	current_level_over_forty_choice: 'Over 40',
	current_level_under_forty_choice: 'Under 40',
	current_level_question: 'What is your current prolactin level?',
	current_issue_question: 'Is this currently an issue?',
};

export const schema = z
	.object({
		[dataConstants.SUICIDAL_THOUGHTS]: optionalString,
		[dataConstants.SEVERITY]: optionalString,
	})
	.superRefine((data, context) => {
		const commonParams = { data, context };
		const suicidalThoughts = data?.[dataConstants.SUICIDAL_THOUGHTS];
		if (includes(suicidalThoughts, ['1', '2', '3'])) {
			superRefineHelper({
				...commonParams,
				dataPath: dataConstants.SEVERITY,
				negativeCondition: isNil,
				message: commonErrors.selectionRequired,
			});
		}
	});
